import UserAgent from "./UserAgent";

const PLAY_STORE_CHROME = "https://play.google.com/store/apps/details?id=com.android.chrome";

class DeepLinkUtils {
    static withQueryParams(url, paramsString) {
        if (!paramsString) return url;
        const [base, hash = ""] = url.split("#");
        const sep = base.includes("?") ? "&" : "?";
        return `${base}${sep}${paramsString}${hash ? "#" + hash : ""}`;
    }

    static buildChromeIntentUrl(url, paramsString = "") {
        const urlWithParams = paramsString ? DeepLinkUtils.withQueryParams(url, paramsString) : url;
        const protocol = urlWithParams.startsWith("https:") ? "https" : "http";
        const stripped = urlWithParams.replace(new RegExp(`^${protocol}://`, "i"), "");

        const finalURL = (
            `intent://${stripped}` +
            `#Intent;scheme=${protocol}` +
            `;action=android.intent.action.VIEW` +
            `;package=com.android.chrome` +
            `;S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_CHROME)}` +
            `;end`
        );

        console.log("[DeepLinkUtils] buildChromeIntentUrl: " + finalURL);
        
        return finalURL;
    }

    static buildGenericIntentUrl(url, paramsString = "") {
        const urlWithParams = paramsString ? DeepLinkUtils.withQueryParams(url, paramsString) : url;
        const protocol = urlWithParams.startsWith("https:") ? "https" : "http";
        const stripped = urlWithParams.replace(new RegExp(`^${protocol}://`, "i"), "");
        
        const finalURL = (
            `intent://${stripped}` +
            `#Intent;scheme=${protocol}` +
            `;action=android.intent.action.VIEW` +
            `;category=android.intent.category.BROWSABLE` +
            `;end`
        );

        console.log("[DeepLinkUtils] buildChromeIntentUrl: " + finalURL);

        return finalURL;
    }

    // --- Web Share helpers ---
    static canUseShare(url) {
        if (!("share" in navigator)) return false;
        try {
            return typeof navigator.canShare !== "function" ? true : navigator.canShare({ url });
        } catch {
            return false;
        }
    }
    
    static async tryShare({ url, title = document.title, text } = {}) {
        if (!DeepLinkUtils.canUseShare(url)) return false;
        try {
            await navigator.share({ url, title, text });
            return true;
        } catch (err) {
            return err && (err.name === "AbortError" || err.name === "NotAllowedError");
        }
    }

    static openInExternalBrowser(url, paramsString) {
        return DeepLinkUtils.buildGenericIntentUrl(url, paramsString);
    }
}

export default DeepLinkUtils;
